module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 24\"><title>copy</title><rect x=\"5.68\" y=\"6.55\" width=\"10.42\" height=\"15.27\" style=\"fill:none\"></rect><path d=\"M13.26,0H1.89A2.05,2.05,0,0,0,0,2.18V17.45H1.89V2.18H13.26Z\" style=\"fill:#c7cdd9\"></path><path d=\"M16.11,4.36H5.68A2.05,2.05,0,0,0,3.79,6.55V21.82A2.05,2.05,0,0,0,5.68,24H16.11A2.05,2.05,0,0,0,18,21.82V6.55A2.05,2.05,0,0,0,16.11,4.36Zm0,17.45H5.68V6.55H16.11Z\" style=\"fill:#c7cdd9\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/copy.svg-inline
// module id = 622
// module chunks = 0